import { Dropdown, MenuItem } from '@components/dropdown';
import { IcoCheckCircle, IcoSelector } from '@components/icons';
import { useIntl } from 'shared/intl/use-intl';

export function SortDropdown<T extends string>({
  options,
  value,
  onChange,
  class: className = '',
}: {
  options: Array<{ value: T; label: string }>;
  value: T;
  onChange(value: T): void;
  class?: string;
}) {
  const intl = useIntl();
  const current = options.find((option) => option.value === value);

  return (
    <Dropdown
      triggerClass={`flex items-center gap-2 px-3 py-1.5 text-sm text-gray-700 border border-gray-300 rounded-md hover:bg-gray-50 transition-colors ${className}`}
      renderMenu={() => (
        <div class="flex flex-col p-2 pb-0 min-w-[180px]">
          {options.map((option) => {
            const isActive = option.value === value;
            return (
              <MenuItem key={option.value} regularCase onClick={() => onChange(option.value)}>
                <span class="flex items-center gap-2">
                  {isActive && <IcoCheckCircle class="w-4 h-4 text-indigo-600" />}
                  <span class={isActive ? 'font-medium text-indigo-600' : ''}>{option.label}</span>
                </span>
              </MenuItem>
            );
          })}
        </div>
      )}
    >
      <IcoSelector class="w-4 h-4" />
      <span class="font-semibold">{intl('Sort:')}</span>
      <span>{current?.label || intl('Select')}</span>
    </Dropdown>
  );
}
